<div class="d-flex align-items-center">
    <img class="breadcrumb-icon cursor" src="/assets/icons/picto-accueil.png" alt="accueil" (click)="goToHomePage()">

    <small class="text secondary fst-italic"> &nbsp; {{title}} </small>
</div>